import Component from 'antd/es/image';
import 'antd/lib/image/style';
export default Component;
